module.exports = __webpack_public_path__ + "img/korboon.1837c526.svg";